import styled from 'styled-components';

export const StyledContent = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 40px;

  .label {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    color: #000000;
    margin-bottom: 24px;
  }
`;